<template>
  <label
    class="radio-check"
    :class="{'radio-check--active': isActive, 'radio-check--disabled': disabled}"
    @click.prevent="emitValue">
    <input
      :id="id"
      :value="id"
      :type="type"
      :checked="value"
      :name="name"
      hidden
      @change="emitValue">
    <span
      class="radio-check__shape"
      :class="[
        display === 'radio' ? 'shape-dot' : 'shape-check',
        stateClass,
      ]" />
    <span class="radio-check__title transition--color">
      <slot />
    </span>
  </label>
</template>

<script>
export default {
  name: 'UiRadioCheck',

  props: {
    // Значение для v-model
    value: {
      type: [String, Number, Boolean],
      default: false,
    },

    // Поведение компонента, checkbox или radio
    type: {
      type: String,
      default: 'checkbox',
      validator: (val) => ['checkbox', 'radio'].includes(val),
    },

    // Отображение компонента, checkbox или radio
    display: {
      type: String,
      default: 'checkbox',
      validator: (val) => ['checkbox', 'radio'].includes(val),
    },

    // id (уникальный идентификатор) для поведения radio-like
    id: {
      type: [String, Number],
      default: '',
    },

    // name (групповой идентификатор) для поведения radio-like
    name: {
      type: String,
      default: '',
    },

    disabled: {
      type: Boolean,
      default: false,
    },

    // для возможности анчекать radio-like
    canUncheck: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    stateClass() {
      if (this.isActive) {
        if (this.display === 'radio') {
          return 'shape-dot--active';
        }
      } else if (this.display === 'checkbox') {
        return 'shape-check--hidden';
      }
      return '';
    },

    isActive() {
      return (this.type === 'radio' && this.value === this.id) || (this.type === 'checkbox' && this.value);
    },
  },

  methods: {
    emitValue() {
      if (this.disabled) {
        return;
      }

      if (this.type === 'radio') {
        let valueToEmit = this.id;
        if (this.canUncheck) {
          valueToEmit = this.value === this.id ? null : this.id;
        }
        this.$emit('input', valueToEmit);
      } else {
        this.$emit('input', !this.value);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
  .radio-check {
    --check-margin: 10px;
    --check-color: #{$color--basic-dark-gray};
    --check-color--active: #{$color--basic-blue};
    --color: #{$color--basic-dark-gray};
    --color--active: #{$color--basic-white};
    --color--disabled: #{$color--basic-light-gray};

    display: grid;
    grid-template-columns: 20px 1fr;
    grid-gap: var(--check-margin);
    align-items: center;
    cursor: pointer;
  }

  .radio-check__shape {
    height: 20px;
    align-self: flex-start;
  }

  .shape-dot {
    --inner-size: 0.5;
    --shape-color: var(--check-color);
  }

  .shape-dot--active {
    --shape-color: var(--check-color--active);
  }

  .shape-check {
    --shape-color: var(--check-color--active);
    --thickness: 3px;
    --max-scale: 0.85;

    border-radius: 3px;
    border: 2px solid var(--check-color--active);
  }

  .shape-check--hidden {
    border-color: var(--check-color);
  }

  .radio-check__title {
    color: var(--color);
  }

  .radio-check--active .radio-check__title {
    color: var(--color--active);
  }

  .radio-check--disabled {
    --check-color: var(--color--disabled);
    --check-color--active: var(--color--disabled);
    --color: var(--color--disabled);
    --color--active: var(--color--disabled);

    cursor: default;
  }
</style>
